<template>
  <div class="">
   <div>
   	<el-avatar shape="square" size="large" :src="require('../assets/img/logo.png')" style="background-color: #fff;" />
   </div>
  </div>
</template>

<script>
export default {
  name: 'download',
  
}
</script>

<style scoped>
#app{
	min-width: auto !important;
}
</style>
